import { memo } from 'react';
import { formatMonthLabel } from '../../utils/format';

export interface MonthNavigatorProps {
  currentMonth: string;
  onPrevMonth: () => void;
  onNextMonth: () => void;
}

export const MonthNavigator = memo(function MonthNavigator({
  currentMonth,
  onPrevMonth,
  onNextMonth,
}: MonthNavigatorProps) {
  return (
    <div className="flex items-center justify-center gap-4">
      <button
        onClick={onPrevMonth}
        className="px-3 py-2 min-w-[44px] min-h-[44px] text-brand-primary hover:bg-brand-secondary/10 rounded transition-colors"
        aria-label="Mes anterior"
      >
        ◀
      </button>
      <span
        data-testid="current-month-display"
        className="text-base sm:text-lg font-medium min-w-[140px] sm:min-w-[160px] text-center"
      >
        {formatMonthLabel(currentMonth)}
      </span>
      <button
        onClick={onNextMonth}
        className="px-3 py-2 min-w-[44px] min-h-[44px] text-brand-primary hover:bg-brand-secondary/10 rounded transition-colors"
        aria-label="Mes siguiente"
      >
        ▶
      </button>
    </div>
  );
});
